import $ from 'jquery';

$('.js-show-all-question').on('click', function (e) {
	e.preventDefault();
	$('.js-question-form .js-check-me-for-in-view.d-none').removeClass(
		'd-none'
	);

	$(this).addClass('d-none');
});
